import {
  Page,
  SyncWriteResponse,
  V3WorkingTimeFrame,
  V3WorkingTimeFrameVersionTask,
  V3WorkingTimeFrameVersionTaskInput,
} from '@crewmeister/shared/src/types';
import { applyMinimalChangesToArray } from '@crewmeister/shared/src/utils/array';
import { applyWriteResponsesToArray } from '@crewmeister/shared/src/utils/v3';
import produce from 'immer';
import { AnyAction } from 'redux';
import { ACTION_NAMES } from '../../constants';

// Action to handle CRUD on WorkingTimeFrame directly
type V3WorkingTimeWriteAction = {
  id: number;
  workingTimeFrame: V3WorkingTimeFrame;
  result: { body: SyncWriteResponse<V3WorkingTimeFrame, number> }[];
};

type V3WorkingTimeFrameLoadAction = {
  type: string;
  result: Page<V3WorkingTimeFrame>;
};

type V3WorkingTimeFrameVersionTaskAction = {
  type: string;
  taskInput: V3WorkingTimeFrameVersionTaskInput;
  result: SyncWriteResponse<V3WorkingTimeFrameVersionTask, string>;
};

// Action to handle WorkingTimeFrame version task
type V3WorkingTimeFrameSliceInRedux = { workingTimeFrames: V3WorkingTimeFrame[] };

const initialState = { workingTimeFrames: [] } as V3WorkingTimeFrameSliceInRedux;

export const v3WorkingTimeFrameReducer = (
  state = initialState,
  action: AnyAction & V3WorkingTimeWriteAction & V3WorkingTimeFrameLoadAction & V3WorkingTimeFrameVersionTaskAction
): V3WorkingTimeFrameSliceInRedux =>
  produce(state, (draft: V3WorkingTimeFrameSliceInRedux) => {
    switch (action.type) {
      case `${ACTION_NAMES.V3_LOAD_WORKING_TIME_FRAME}_SUCCESS`:
        applyMinimalChangesToArray(
          draft.workingTimeFrames,
          action.result.content.toSorted(
            (a: V3WorkingTimeFrame, b: V3WorkingTimeFrame) =>
              a.crewId - b.crewId ||
              (a.userId ?? 0) - (b.userId ?? 0) ||
              new Date(a.validFrom).getTime() - new Date(b.validFrom).getTime()
          ),
          (element) => element.crewId === action.crewId
        );
        break;
      case `${ACTION_NAMES.V3_WORKING_TIME_FRAME_TASK_EXECUTE}_SUCCESS`:
        applyWriteResponsesToArray(
          draft.workingTimeFrames,
          action.result.resourceAfterWrite?.output?.workingTimeFrameResponses ?? []
        );
        break;
      case `${ACTION_NAMES.V3_WORKING_TIME_FRAME_WRITE}_SUCCESS`:
        applyWriteResponsesToArray(
          draft.workingTimeFrames,
          action.result.map(({ body }) => body)
        );
        break;
      default:
      // nothing to do => immer returns the original object
    }
  });
